function Radio(props) {
	const { value, name, disabled, checked, onChange, className, children } = props;
	return (
		<label className={className ? `gs-check-item ${className}` : 'gs-check-item'}>
			<input
				type="radio"
				id={value}
				name={name}
				value={value}
				defaultChecked={checked}
				disabled={disabled}
				onChange={onChange}
			/>
			<span>{children ? <em>{children}</em> : null}</span>
		</label>
	);
}

function RadioGroup(props) {
	const { id, label, name, ckeckOptions, checked, onChange = () => {}, className, itemClassName } = props;

	const radioItem = ckeckOptions.map((option, i) => {
		const { value, label, disabled } = option;
		return (
			<Radio
				key={value}
				id={value}
				className={itemClassName}
				name={name}
				value={value}
				checked={value === checked}
				disabled={disabled}
				onChange={onChange}
			>
				{label}
			</Radio>
		);
	});

	return (
		<div className={className ? `gs-check-group ${className}` : 'gs-check-group'}>
			{label && (
				<div id={`${id}-label`} className="gs-group-label">
					{label}
				</div>
			)}
			<div
				id={id}
				className="gs-check-con"
				role="group"
				aria-label={label ? undefined : `${id}-label`}
				aria-labelledby={label ? `${id}-label` : undefined}
			>
				{radioItem}
			</div>
		</div>
	);
}

export { Radio, RadioGroup };
